/*
// KJR 2014-08-22
// Global JS included on every page.  Add all your common script inits here.
*/

//$(document).ready(function() {
//$(function() { // Shorthand for $( document ).ready()
jQuery(function($){
	// executes when HTML-Document is loaded and DOM is ready

	//fix for Windows Phone 8
	if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
		var msViewportStyle = document.createElement('style');
		msViewportStyle.appendChild(
			document.createTextNode(
				'@-ms-viewport{width:auto!important}'
			)
		);
		document.querySelector('head').appendChild(msViewportStyle);
	}

	//calculate masthead dimensions & fix height during load
	var mastheadRatio = $("#masthead").data('ratio');
	var mastheadWidth = $("#masthead").width();
	var mastheadHeight = (1/mastheadRatio*mastheadWidth);
	$("#masthead").css('height', mastheadHeight);
	//NOTE: inline styles removed on window.onload function below

	//menu toggle
	function pushyOn() {
		//$("#top-nav").css('z-index', 'auto');
		$('.pushy').addClass('visible');
		$("body").addClass("pushy-open-right");
		$('.site-overlay').width($(window).outerWidth() - $('.pushy-right').outerWidth());
		//remove tabindex for all items under pushy div
		$(".pushy").find('a, button').each(function() {
			$(this).removeAttr('tabindex');
		});
	}
	function pushyOff() {
		//$("#top-nav").removeAttr("style");
		$("body").removeClass("pushy-open-right");
		//add tabindex=-1 for all items under pushy div
		$(".pushy").find('a, button').each(function() {
			$(this).attr('tabindex', '-1');
		});
	}
	$("#mobile-nav").click(function () {
		pushyOn();
	});
	$(".pushy-link, .site-overlay").click(function () {
		pushyOff();
	});
	pushyOff();

	//track phone number taps & clicks
	$('.tel').on('click', function(e){
		e.preventDefault();
		trackEvent('Mobile', 'Click to Call', $(this).data('tel'));
		window.location = 'tel:'+$(this).data('tel');
	});

	//hide pushy scrollbar
	$scrollbarWidth = getScrollbarWidth();
	$(".pushy").css('margin-right', '-'+$scrollbarWidth+'px');

	//animate the scroll to top
	addScrollToOnClick('.back2top', 'body', 500);
	$('.skip_section a').each(function() {
		var targetElm = this.href.substring(this.href.indexOf("#"));
		addScrollToOnClick(this, targetElm, 500);
	});

	//decrypt encrypted mailto links
	$('.mailto').each(function() {
		var strEncrypted = $(this).html();
		var parts = strEncrypted.split("|");
		var email = rot13(decodeBase64(parts[0]));
		var display = rot13(decodeBase64(parts[1]));
		var html = '<a class="email" href="mailto:'+email+'">'+display+'</a>';
		$(this).html(html);
	});

	//set noopener for all external links
	$('a[target="_blank"]').each(function() {
		var rel = '';
		if ( $(this).attr("rel") ) {
			rel = $(this).attr("rel");
			rel = rel.replace('noopener', '').trim();
			if (rel.length > 0) {
				rel += ' ';
			}
		}
		$(this).attr('rel', rel+'noopener');
	});

	run_location_finder(1, 'html', '.header_phone');
	//backward compatibility for accessible mega menu
	// $(".megamenu").accessibleMegaMenu({
	// 	uuidPrefix: "accessible-megamenu",
	// 	menuClass: "nav-menu",
	// 	topNavItemClass: "nav-item",
	// 	panelClass: "sub-nav",
	// 	panelGroupClass: "sub-nav-group",
	// 	hoverClass: "hover",
	// 	focusClass: "focus",
	// 	openClass: "open"
	// });
	$('a.sub-nav').removeClass('sub-nav');

	header_height = $('.header_cont').outerHeight();
	adjust_advisory_position();

//}); //End document.ready

/*window.addEventListener('focus', function() {
	//console.log('Focused element id: '+$(':focus').attr('id')+', class = '+$(':focus').attr('class')+', tagName = '+$(':focus').prop("tagName")+', href = '+$(':focus').attr("href"));
	var focused = $(':focus')[0];
	console.log(focused);
}, true);*/

//window.onload = function() {
	window.addEventListener('load', function() {
		// executes when complete page is fully loaded, including all frames, objects and images
		
		//remove fixed height on masthead once page has fully loaded
		$("#masthead").removeAttr('style');
		//}; //End window.onload
	}, true); //End window.onload
	
	$(document).scroll(function() {
		header_height = $('.header_cont').outerHeight();
		adjust_advisory_position();
	});
	
	function adjust_advisory_position() {
		var advisory_position = 200;
		if($(document).scrollTop() < header_height /*&& $(window).width() > 600*/) {
			advisory_position = header_height - $(document).scrollTop();
		}
		else {
			advisory_position = 0;
		}
		$('#fixed_advisory').css('top', advisory_position);
	}
	
	function html5FormCompatibility() {
		$(function() {
			if (!Modernizr.formvalidation) {
				//console.log('no formvalidation');
				$.when(
					$.getCSS({ href: "css/jquery.qtip.min.css", media: "screen" }),
					$.getScript( "js/jquery.qtip.min.js" ),
					$.getScript( "js/nwxforms.min.js" ),
					$.Deferred(function( deferred ){
						$( deferred.resolve );
					})
					).done(function(){
						//the scripts are all loaded
						nwxforms(window);
					});
				}
				if (!Modernizr.inputtypes.date) {
					//load jquery ui and instantiate datepicker
					$.when(
						$.getCSS({ href: "https://code.jquery.com/ui/1.12.1/themes/base/jquery-ui.css", media: "screen" }),
						$.getScript( "https://code.jquery.com/ui/1.12.1/jquery-ui.min.js" ),
						$.Deferred(function( deferred ){
							$( deferred.resolve );
						})
						).done(function(){
							//the scripts are all loaded
							$( "input[type='date']" ).datepicker();
						});
					}
				});
			}
			
			//Google Analytics Event Tracking
			//https://developers.google.com/analytics/devguides/collection/analyticsjs/events
			function trackEvent(category, action, label) {
				//EXAMPLES:
				//ga('send', 'event', 'Videos', 'Play', 'Gone With the Wind']);
				//ga('send', 'event', 'Videos', 'Downloaded', 'Gone With the Wind']);
				//ga('send', 'event', 'Downloads', 'PDF', 'Expense Report']);
				//ga('send', 'event', 'datasheet-download', 'click', 'http://www.myurl.com');
				if (typeof ga !== 'undefined') {
					//ga('send', 'event', category, action, label);
					gtag('event', action, {
						// Event parameters
						'event_category': category,
						'event_label': label
					});
				} else {
					console.log('Simulating GA event tracking: category = "'+category+'", action = "'+action+'", label = "'+label+'"');
				}
			}
			
			function addScrollToOnClick(clickedElm, targetElm, animationDuration) {
				$(clickedElm).click(function(event) {
					//console.log('addScrollToOnClick: '+targetElm);
					$('html, body').animate({scrollTop: $(targetElm).offset().top}, animationDuration);
					return true;
				});
			}
			
			function getScrollbarWidth() {
				var outer = document.createElement("div");
				outer.style.visibility = "hidden";
				outer.style.width = "100px";
				document.body.appendChild(outer);
				
				var widthNoScroll = outer.offsetWidth;
				// force scrollbars
				outer.style.overflow = "scroll";
				
				// add innerdiv
				var inner = document.createElement("div");
				inner.style.width = "100%";
				outer.appendChild(inner);
				
				var widthWithScroll = inner.offsetWidth;
				
				// remove divs
				outer.parentNode.removeChild(outer);
				
				return widthNoScroll - widthWithScroll;
			}
			
			/*
			* jQuery getCSS Plugin
			* Copyright 2013, intesso
			* MIT license.
			*
			* cross browser function to dynamically load an external css file.
			* see: [github page](http://intesso.github.com/jquery-getCSS/)
			*
			*/
			
			(function() {
				/*
				arguments: attributes
				attributes can be a string: then it goes directly inside the href attribute.
				e.g.: $.getCSS("fresh.css")
				attributes can also be an objcet.
				e.g.: $.getCSS({href:"cool.css", media:"print"})
				or:	$.getCSS({href:"/styles/forest.css", media:"screen"})
				*/
				var getCSS = function(attributes) {
					// setting default attributes
					if(typeof attributes === "string") {
						var href = attributes;
						attributes = {
							href: href
						};
					}
					if(!attributes.rel) {
						attributes.rel = "stylesheet";
					}
					// appending the stylesheet
					// no jQuery stuff here, just plain dom manipulations
					var styleSheet = document.createElement("link");
					for(var key in attributes) {
						styleSheet.setAttribute(key, attributes[key]);
					}
					var head = document.getElementsByTagName("head")[0];
					head.appendChild(styleSheet);
				};
				
				if(typeof jQuery === "undefined") {
					window.getCSS = getCSS;
				} else {
					jQuery.getCSS = getCSS;
				}
				
			})();
		}); //End document.ready